(function(angular){
    'use strict';

    angular.module('aprima-core-ui').component('apErxRequestProvider', {
        templateUrl: '/core-ui/component-views/ap-erx-request-provider.html',
        bindings: {
            label: '<',
            requestedProvider: '<',
        },
        controllerAs: 'vm',
        controller: [
            ApErxRequestProvider,
        ],
    });

    function ApErxRequestProvider(
    ) {
        var vm = this;
        vm.isOpen = false;
        vm.identification = identification;

        function identification(provider) {
            if(!provider) {
                return null;
            }

            var description = '';
            if(provider.PhysicianReferenceType) {
                description += provider.PhysicianReferenceType + ': ';
            }
            if(provider.PhysicianReferenceNumber) {
                description += provider.PhysicianReferenceNumber;
            }
            return description;
        }
    }

})(window.angular);
